export class PagedRequest {
  public pageSize: number;
  public pageNumber: number;
}
